function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.299,
    height: 19.014,
    viewBox: "0 0 11.299 19.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8356",
    d: "m349.885 498.358-4.278-4.148-4.209 4.149a.543.543 0 0 1-.9-.486V480.5h10.3v17.372a.554.554 0 0 1-.913.486z",
    transform: "translate(-340 -480)",
    style: {
      fill: "#067EEF",
      stroke: "#067EEF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkSelected);
export default __webpack_public_path__ + "static/media/bookmark-selected.f1688c34e1c1b3cdcd789eee251f2114.svg";
export { ForwardRef as ReactComponent };